import { DEFAULT_BRANDING_COLORS } from './defaults'
import { isValidHexColor } from './hexColor'
import type { BrandingColors, BrandingConfigurationType } from './types'

const readHexColor = (value: unknown, fallback: string): string => (typeof value === 'string' && isValidHexColor(value) ? value : fallback)

export const normalizeBrandingColors = (configuration?: Partial<BrandingConfigurationType> | null): BrandingColors => ({
  accentColor: readHexColor(configuration?.accentColor, DEFAULT_BRANDING_COLORS.accentColor),
  timerChipBackgroundColor: readHexColor(configuration?.timerChipBackgroundColor, DEFAULT_BRANDING_COLORS.timerChipBackgroundColor),
  timerChipTextColor: readHexColor(configuration?.timerChipTextColor, DEFAULT_BRANDING_COLORS.timerChipTextColor),
  footerTextColor: readHexColor(configuration?.footerTextColor, DEFAULT_BRANDING_COLORS.footerTextColor),
  footerTextHoverColor: readHexColor(configuration?.footerTextHoverColor, DEFAULT_BRANDING_COLORS.footerTextHoverColor),
  headerBackgroundColor: readHexColor(configuration?.headerBackgroundColor, DEFAULT_BRANDING_COLORS.headerBackgroundColor),
  emailHeaderBackgroundColor: readHexColor(
    configuration?.emailHeaderBackgroundColor,
    readHexColor(configuration?.headerBackgroundColor, DEFAULT_BRANDING_COLORS.emailHeaderBackgroundColor)
  ),
  footerBackgroundColor: readHexColor(configuration?.footerBackgroundColor, DEFAULT_BRANDING_COLORS.footerBackgroundColor),
  pageBackgroundColor: readHexColor(configuration?.pageBackgroundColor, DEFAULT_BRANDING_COLORS.pageBackgroundColor),
  buttonColor: readHexColor(configuration?.buttonColor, DEFAULT_BRANDING_COLORS.buttonColor),
  buttonTextColor: readHexColor(configuration?.buttonTextColor, DEFAULT_BRANDING_COLORS.buttonTextColor),
  highlightChipBackgroundColor: readHexColor(configuration?.highlightChipBackgroundColor, DEFAULT_BRANDING_COLORS.highlightChipBackgroundColor),
  highlightChipTextColor: readHexColor(configuration?.highlightChipTextColor, DEFAULT_BRANDING_COLORS.highlightChipTextColor),
})
